import { render } from "./Monster.vue?vue&type=template&id=2c03cf2a"
import script from "./Monster.vue?vue&type=script&lang=js"
export * from "./Monster.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__